import type { TouchEvent, WheelEvent } from 'react'

/**
 * Spread onto a scrolling list that is portalled out of a dialog or sheet.
 *
 * An open Radix dialog locks scrolling everywhere outside itself: it listens
 * for wheel and touch moves on the document and cancels any that did not start
 * inside the dialog. A popover's list is portalled to `body`, so it is
 * "outside" — the scrollbar drags, but the mouse wheel and trackpad do
 * nothing. Stopping the event at the list keeps it from reaching that
 * listener; the browser still scrolls the list.
 */
export const portalScroll = {
  onWheel: (event: WheelEvent) => event.stopPropagation(),
  onTouchMove: (event: TouchEvent) => event.stopPropagation(),
}
